import React from "react";
import { Button, ButtonProps } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

function AddProjectButtons({ buttonProps }: any) {
  const navigate = useNavigate();

  const handleNavigateToCreateProject = () => {
    navigate("/projects/create");
  };

  return (
    <Button
      {...buttonProps}
      onClick={handleNavigateToCreateProject}
      colorScheme="teal"
    >
      + Create Project
    </Button>
  );
}

export default AddProjectButtons;
